export const responseErrorMessage = async (response: Response): Promise<string> => {
  if (response.status === 401) {
    return "Your DVR session has expired. Sign in again, then retry your change.";
  }
  try {
    const payload = await response.json() as { error?: { message?: string } };
    return payload.error?.message ?? "The request could not be completed.";
  } catch {
    return "The request could not be completed.";
  }
};
